/*

Usage:

ES6:
import ve from "vue-esc.js"
Vue.use( ve )

ES5:
var ve = require("vue-esc.js")
Vue.use( ve )

template:
<div
  v-esc="onClose"
>
...
</div>
*/
let vueEsc = {};

vueEsc.install = function ( Vue ) {
	let handle;
	
	Vue.directive(
		"esc",
		{
			bind( el, binding, vnode ) {
				handle = e => {
					const kc = e ? ( e.which ? e.which : e.keyCode ) : undefined;
					if ( kc == 27 ) typeof( binding.value ) === "function" ? binding.value() : vnode.context[ binding.value ]();
				};
				
				document.addEventListener( "keydown", handle );
			},
			
			unbind() {
				document.removeEventListener( "keydown", handle );
			}
		}
	);
};

if ( typeof window !== "undefined" && window.Vue ) {
	window.Vue.use( vueEsc )
}

export default vueEsc;
